import Loadable from "react-loadable";

const LazyCreateFeedback = Loadable({
  loader: () => import(/* webpackChunkName: 'create-feedback' */ "./CreateFeedback"),
  loading: () => 'loading...'
});

export default LazyCreateFeedback;
